import React from "react";

const ThankYou = ({destinationUrl}) => {
  return (
    <section className="thank-you">
        <a className="skip_desktop" href={destinationUrl}>SKIP</a>
        <div className="thankyou_container">
            <img src={require("../../assets/images/Thankyou-Animation.gif")} alt="" />
            <p> <span>'Thankyou</span> for submitting your preferences</p>
            <a href={destinationUrl} className="mobile-skip">SKIP</a>
        </div>
    </section>  
  );
};

export default ThankYou;
